import React from 'react';
import { useCachedImageUrl } from '../hooks/useCachedImageUrl';
import './CachedImage.css';

/**
 * Renders an <img> that uses cached blob URLs for Firebase Storage images
 * so the browser doesn't refetch the same image on every view.
 * While loading, shows a skeleton shimmer instead of a placeholder icon.
 * onLoad is only called when the final image (not placeholder) has loaded.
 */
function CachedImage({ src, alt = '', className, placeholder = '/placeholder.png', onLoad, onError, ...props }) {
  const { src: cachedSrc, loading } = useCachedImageUrl(src);
  const displaySrc = loading ? placeholder : (cachedSrc || src || placeholder);
  const handleLoad = (e) => {
    if (!loading) onLoad?.(e);
  };
  const handleError = (e) => {
    onError?.(e);
  };

  if (loading) {
    return (
      <div className={`cached-image-skeleton-wrap ${className || ''}`.trim()} aria-hidden="true">
        <div className="cached-image-skeleton" />
      </div>
    );
  }

  return (
    <img
      src={displaySrc}
      alt={alt}
      className={className || undefined}
      onLoad={handleLoad}
      onError={handleError}
      {...props}
    />
  );
}

export default CachedImage;
